/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React, { useEffect } from "react";

//@Packages
import { useSelector } from "react-redux";
import { Routes, Route, useNavigate } from "react-router-dom";

//@Components
import ViewDevice from "./../../components/viewdevice";
import EditDevice from "./../../components/editdevice";
import LandingPage from "./../../components/landingpage";
import CreateDevice from "./../../components/createdevice";
import BlukAssignment from "../../components/BlukAssignment";
import AssignGatewayPanel from "../../components/AssignGatewayPanel";

//@Constants
import { ROUTE_PATH } from "./../../utils/constants";

//@Store
import { RootState } from "../../store";
import ReRegistration from "../../components/reregistration";

//@Functional Component
const RbmRoutes = () => {
  const navigate = useNavigate();

  const { selectedOrg, siteView } = useSelector((state: RootState) => state.global);

  useEffect(() => {
    if (selectedOrg) {
      // Replace in the site views: the iframe shares the host's session history, so a push would need an extra Back click there.
      if (siteView) {
        navigate(ROUTE_PATH.landingPage, { replace: true });
      } else {
        navigate(ROUTE_PATH.landingPage);
      }
    }
  }, [selectedOrg]);

  return (
    <Routes>
      <>
        <Route
          path={ROUTE_PATH.landingPage}
          element={siteView === "assignPanel" ? <AssignGatewayPanel /> : <LandingPage />}
        />
        <Route path={ROUTE_PATH.createDevice} element={<CreateDevice />} />
        <Route path={`${ROUTE_PATH.editDevice}/:id`} element={<EditDevice />} />
        <Route path={`${ROUTE_PATH.viewDevice}/:id`} element={<ViewDevice />} />
        <Route path={`${ROUTE_PATH.reRegistration}/:id`} element={<ReRegistration />} />
        <Route path={ROUTE_PATH.bulkAssignment} element={<BlukAssignment />} />
      </>
    </Routes>
  );
};

export default RbmRoutes;